import { gsap } from 'gsap';
export default function ScreenLoader (timingIn, timingOut){
 // gsap.set($('*[data-barba-loadingscreen]'), {autoAlpha: 0});
  this.show = function(){
    return new Promise(function(resolve){
      let tl = gsap.timeline( {
        repeat:0,
        paused: true,
        onStart:function(){
        },
        onComplete: function(){
          $('*[data-barba-loadingscreen]').addClass('active')
          resolve(true);

        }
      });
      let $target = $('[data-scroll-section-inview]').length != 0 ? '[data-scroll-section-inview]' : '[data-scroll-section]';
      tl.fromTo($($target),
        {autoAlpha:1,ease:"circ.in",duration:.45},
        {autoAlpha:0,ease:"circ.in",duration:.45},'hideElements');
      if (window.scene ){
        /*window.scene.smoke.smokeParticles.forEach((element,index) => {  
          console.log(index,element)
          tl.to(element.position,{
            x:  index % 3  == 0 ? -1 * window.outerWidth : window.outerWidth,
            y:  index % 3  == 0 ? 1 * window.outerHeight : -1 * window.outerHeight,
            z: 1000,
            duration:2,
            ease:'power2.in'
          },'fadeSmoke')          
        });*/
      
        /*$($target).find('[data-dynamic-text]').each(function(){
          let targetHide = window.scene.text.getText($(this).attr('data-uuid'));
          console.log(targetHide)
          if (targetHide){
            gsap.to(targetHide.material.uniforms.uAlpha,
            {
              value: 0,
              duration:.45,
              ease:'circ.in'
            })
          }
          
        })*/
      }

    
      tl.play();
    });
  }
  this.hide =  function(){
      return new Promise(function(resolve){
        
        let tl = gsap.timeline( {
	          repeat:0,
	          paused: true,
            onStart:function(){
              appEvent.trigger('app:threejsAnimation:start');
              $('*[data-barba-loadingscreen]').removeClass('active')


            },
	          onComplete: function(){
              
              resolve(true);
    		  }
        });
       
        tl.fromTo($('[data-barba="container"]:last-of-type,footer'),
          {autoAlpha:0,ease:"circ.out"},
          {autoAlpha:1,ease:"circ.out",duration:.8},'enter');
          tl.play();
      });
       
  }
}
